import { Properties } from "../../core/internal/model/model"
import { Page } from "../../core/internal/page/Page"
import BrowserPropertyGenerator from "./BrowserPropertyGenerator"

export interface BrowserPropertyProvider {
  getBrowserProperties(): Properties
}

export default class DefaultBrowserPropertyProvider implements BrowserPropertyProvider {
  getBrowserProperties(): Properties {
    return BrowserPropertyGenerator.generate(window, Page.createWithCurrentPage())
  }
}
